import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "subaru-maintenance-schedule" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "subaru-maintenance-schedule__title" }, " Maintenance Schedule Lookup ", -1 /* HOISTED */);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "subaru-maintenance-schedule__steps" }, [
    /*#__PURE__*/ _createTextVNode(" Use This Simple Tool To Determine What Service is Right For Your Subaru In "),
    /*#__PURE__*/ _createElementVNode("b", null, "Four Easy Steps")
], -1 /* HOISTED */);
const _hoisted_4 = {
    key: 0,
    class: "subaru-maintenance-schedule__form-questions"
};
const _hoisted_5 = { class: "subaru-maintenance-schedule__form-results" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_formQuestionComponent = _resolveComponent("formQuestionComponent");
    const _component_maintenanceScheduleResults = _resolveComponent("maintenanceScheduleResults");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (_ctx.yearQuestion)
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createVNode(_component_formQuestionComponent, {
                    id: "maintenanceScheduleQuestionOne",
                    class: "form-question form-question--one",
                    question: _ctx.yearQuestion
                }, null, 8 /* PROPS */, ["question"]),
                _createVNode(_component_formQuestionComponent, {
                    id: "maintenanceScheduleQuestionTwo",
                    class: "form-question form-question--two",
                    "aria-hidden": _ctx.enableModel ? null : true,
                    question: _ctx.modelQuestion
                }, null, 8 /* PROPS */, ["aria-hidden", "question"]),
                _createVNode(_component_formQuestionComponent, {
                    id: "maintenanceScheduleQuestionThree",
                    class: "form-question form-question--three",
                    "aria-hidden": _ctx.enableTrim ? null : true,
                    inert: _ctx.enableTrim ? null : true,
                    question: _ctx.trimQuestion
                }, null, 8 /* PROPS */, ["aria-hidden", "inert", "question"]),
                _createVNode(_component_formQuestionComponent, {
                    id: "maintenanceScheduleQuestionFour",
                    class: "form-question form-question--four",
                    "aria-hidden": _ctx.enableMileage ? null : true,
                    inert: _ctx.enableMileage ? null : true,
                    question: _ctx.mileageQuestion
                }, null, 8 /* PROPS */, ["aria-hidden", "inert", "question"])
            ]))
            : _createCommentVNode("v-if", true),
        _createElementVNode("section", _hoisted_5, [
            (_ctx.displayMaintenanceScheduleResults)
                ? (_openBlock(), _createBlock(_component_maintenanceScheduleResults, { key: 0 }))
                : _createCommentVNode("v-if", true)
        ])
    ]));
}
